/* ============================================================
   OUR TECHNOLOGIES — scroll reveal
   Adds .is-visible to .st-reveal elements as they enter viewport.
   Vanilla, zero deps, ~1KB.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var els = document.querySelectorAll('.st-reveal');
    if (!els.length) return;

    // No IntersectionObserver? Show everything immediately.
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -8% 0px'
    });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();